// localStorage key for saving the authorization token
export default '/sally/ops4/dashboard/token';
